var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpanish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 19.29 12.869",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clippath);}.cls-3{fill:#f9c853;}.cls-4{fill:#fff;}.cls-5{fill:#a1181d;}.cls-6{fill:#cd3638;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    width: 19.29,
    height: 12.86
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Text_Generator"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m0,.009h19.252v12.86H0V.009Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m0,.009h19.252v3.429H0V.009Zm0,9.431h19.252v3.429H0v-3.429Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m0,3.431h19.252v6.016H0V3.431Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m6.674,6.01h.856v.429h-.856v-.429Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m6.161,7.296c0,.257.257.429.513.429s.513-.171.513-.429l.086-1.286h-1.198l.086,1.286Zm-.513-1.286c0-.257.171-.429.342-.429h1.283c.257,0,.428.171.428.343v.086l-.086,1.286c-.086.514-.428.857-.941.857s-.856-.343-.941-.857l-.086-1.286Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m5.818,6.439h1.711v.429h-.428l-.428.857-.428-.857h-.428v-.429Zm-1.283-1.286h.856v3.001h-.856v-3.001Zm3.423,0h.856v3.001h-.856v-3.001Zm-2.139-.429c0-.257.171-.429.428-.429h.856c.257,0,.428.171.428.429v.171c0,.171-.086.257-.257.257h-1.283c-.086,0-.171-.086-.171-.171v-.257Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpanish);
export default __webpack_public_path__ + "static/media/spanish.5de545f1ce1b3826a286156a3984fdd5.svg";
export { ForwardRef as ReactComponent };